// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productCountStyles } from "@eisinc/Overrides/Widgets/ProductList/ProductListProductCount";
import Filter from "@eisinc/XDL/Icons/Filter";
import { fontConfig } from "@eisinc/XDL/PreStyle/typography";
import { color, createLinkIconStyles, xScreen } from "@eisinc/XDL/Utilities";
import { css } from "styled-components";

productCountStyles.wrapper = {};

productCountStyles.countAndFilterWrapper = {
    css: css`
        display: flex;
        padding-bottom: 8px;
        border-bottom: 1px solid ${color("common.border")};
        margin-bottom: 12px;
        ${xScreen("lte", "md")} {
            padding-bottom: 12px;
        }
        ${({ totalItemCount }: any) =>
            totalItemCount
                ? css`
                      justify-content: space-between;
                  `
                : css`
                      justify-content: flex-end;
                  `}
    `,
};

productCountStyles.itemsText = {
    variant: "h4",
    css: css`
        margin-bottom: 0;
        display: flex;
    `,
};

productCountStyles.queryText = {
    variant: "h4",
    forwardAs: "span",
    weight: fontConfig.weight.regular,
    css: css`
        margin-bottom: 0;
    `,
};

productCountStyles.filter = {
    ...createLinkIconStyles({ icon: Filter, sizeVariant: "large" }),
    css: css`
        display: none;
        ${xScreen("lte", "md")} {
            display: flex;
        }
    `,
};
